import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";
import { emailValidate } from "../../utils/validation";
import { useUser } from "../../hooks/useUser";

function LoginSection() {
  const navigate = useNavigate();
  const { login , authlogin} = useUser();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");
  const [passwordOn, setPasswordOn] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setEmailError("");
    setPasswordError("");
  }, [email, password]);

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.keyCode === 13) {
        handleLogin();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [email, password]);

  const handleForgot = () => {
    navigate(Paths.forgot);
  };

  const handleSignUp = () => {
    navigate(Paths.signup);
  };

  const handleLogin = async () => {
    const invalidEmail = emailValidate(email);
    if (invalidEmail) {
      return setEmailError(invalidEmail);
    }
    if (!password) {
      return setPasswordError("Password is required");
    }
    await login({ email, password, setLoading });
  };


  const AuthLogin = async() => {
    await authlogin()
  }

  return (
    <div className={ClassName.container}>
      <div className="bg-[#F8F8F8] rounded-2xl w-full max-w-[540px] py-6 px-3 lg:px-6 flex flex-col mx-2">
        <span className="text-3xl lg:text-4xl font-bold mb-4">
          Sign in to your account
        </span>
        <span className={ClassName.label}>Your email address</span>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={ClassName.input}
        />
        {emailError && <span className={ClassName.error}>{emailError}</span>}
        <span className={ClassName.label}>Your password</span>
        <div className={ClassName.input}>
          <input
            type={passwordOn ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-transparent flex flex-1"
          />
          <img
            src={passwordOn ? "/IconEyeOn.svg" : "/IconEyeOff.svg"}
            alt=""
            className="w-5 h-5 object-contain cursor-pointer"
            onClick={() => setPasswordOn(!passwordOn)}
          />
        </div>
        {passwordError && (
          <span className={ClassName.error}>{passwordError}</span>
        )}
        <button
          onClick={handleLogin}
          className="h-12 w-full rounded-lg bg-primary text-white font-bold text-sm lg:text-base mt-4"
        >
          {loading ? "Please wait ..." : "Login"}
        </button>

        {/* Divider */}
        <div className="relative flex items-center my-6">
          <div className="w-full border-t border-gray-300"></div>
          <span className="px-3 text-gray-500 text-sm">or</span>
          <div className="w-full border-t border-gray-300"></div>
        </div>

        {/* Google Sign-in Button */}
        <button className="flex items-center justify-center border border-gray-300 rounded-lg w-full py-2 text-gray-700 font-medium hover:bg-gray-100" onClick={AuthLogin}>
          <img src="/google-image.jpeg" alt="Google icon" className="w-5 h-5 mr-2" />
          Sign in with Google
        </button>

        <div className="w-full flex flex-col items-center mt-4">
          <span
            className={`${ClassName.label} cursor-pointer`}
            onClick={handleForgot}
          >
            I have forgotten my password
          </span>
          <span
            className={`${ClassName.label} cursor-pointer mt-0 text-[#B5B5B5]`}
          >
            Don't have an account?
            <span className="text-primary" onClick={handleSignUp}>
              {" "}
              Signup
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default LoginSection;

const ClassName = {
  container: "w-full h-screen flex items-center justify-center",
  input:
    "border rounded-lg flex flex-1 px-4 py-3 bg-transparent border-[#DBDBDB]",
  error: "text-red-600 text-sm mt-2 mb-2",
  label: "text-[#818083] text-sm lg:text-base font-bold mb-1 mt-4",
};
